import {TableCell, TableRow} from 'common/components/data-table/types';
import {SegmentId} from 'common/report/models/funnels/types';

export enum StatSigDisplayStatusColor {
  Green = `$stat-sig-green`,
  Red = `$stat-sig-red`,
}

export type StatSigDisplay = {
  /** Confidence that the variation in the segment's conversion rate is not driven by random chance */
  confidence: string;
  /** mp-color representing the interestingness */
  status?: StatSigDisplayStatusColor;
  /** string label to use in the UI */
  label?: string;
};

export interface FunnelTableRow extends TableRow<TableCell> {
  /** Formatted name of segment */
  header: string;
  /** raw segment names (used as an array for multi seg) */
  props: SegmentId[];
  /** raw segment name */
  prop: string;
  /** overall conversion ratio for the segment */
  overall: number;
  /** Information needed for rendering a table row */
  displayInfo: {
    /** Conversion time statistics between Funnel steps */
    averageTimeBetweenSteps: number[];
    /** Raw conversion counts for each Funnel step */
    steps: Array<{count: number; conversionRatio: number}>;
  };
  isSelected: boolean;
  checkedColor?: string;
  isControlGroup?: boolean;
  /** Information needed for rendering the statistical significance of each segment */
  statSig?: StatSigDisplay;
}
